import './index.less';

import {
  Box,
  Spinner,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTable } from 'react-table';

import SmartTooltip from '../SmartTooltip';

interface TableProps {
  columns: any[];
  data: any[];
  loading?: boolean;
  noData?: any;
  bodyHeight?: string;
  minBodyHeight?: string;
  maxBodyHeight?: string;
  tableStyle?: any;
}
const ReportTable = (props: TableProps) => {
  // props
  const {
    loading,
    noData,
    columns,
    data,
    bodyHeight = 'auto',
    minBodyHeight = 'unset',
    maxBodyHeight = 'unset',
    tableStyle = {},
  } = props;
  const tableHeaderRef = React.createRef();
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    // selectedFlatRows,
    // state: { selectedRowIds },
  } = useTable({
    columns,
    data,
  });
  return (
    <Box className="container">
      <Table className="table" style={tableStyle} {...getTableProps()}>
        <TableHeader ref={tableHeaderRef}>
          {headerGroups.map((headerGroup, index) => (
            <TableHeaderRow
              {...headerGroup.getHeaderGroupProps()}
              key={`headerRow${index}`}
              width="100%"
            >
              {headerGroup.headers.map((column: any, columnIndex: number) => (
                <TableHeaderCell
                  width={column.width}
                  minWidth={column?.minWidth}
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  textAlign="left"
                  color={colorStyle.color.secondary}
                  {...column.getHeaderProps()}
                  {...column.customProps}
                  key={`headerCell${columnIndex}`}
                >
                  {column.render('Header')}
                </TableHeaderCell>
              ))}
            </TableHeaderRow>
          ))}
        </TableHeader>
        {data?.length > 0 ? (
          <TableBody
            {...getTableBodyProps()}
            className="body"
            height={bodyHeight}
            minHeight={minBodyHeight}
            maxHeight={maxBodyHeight}
          >
            {rows.map((row, i) => {
              prepareRow(row);
              const rowProps = row.getRowProps();
              // const isChecked = Object.keys(selectedRowIds).indexOf(row.id) >= 0;
              return (
                <TableRow
                  {...rowProps}
                  // {...isChecked && { bg: 'rgba(255, 255, 255, 0.08)' }}
                  _hover={{
                    bg: colorStyle.background.selected,
                  }}
                  key={`tableRow${i}`}
                  width="100%"
                >
                  {row.cells.map((cell: any) => {
                    const { column } = cell;
                    const { width, minWidth = 0 } = column;
                    return (
                      <TableCell
                        height="40px"
                        width={width}
                        minWidth={minWidth}
                        {...cell.getCellProps()}
                        textAlign="left"
                        key={column.id || column.Header}
                      >
                        {column.id === 'selection' || column.noToolTip ? (
                          cell.render('Cell')
                        ) : (
                          <SmartTooltip>{cell.render('Cell')}</SmartTooltip>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        ) : (
          <div
            className="noData"
            style={{
              height: 'auto',
              maxHeight: 'unset',
            }}
          >
            {!loading && (
              <>
                {noData ? (
                  noData
                ) : (
                  <Text color={colorStyle.color.secondary}>
                    {t('reportCommon.noData')}
                  </Text>
                )}
              </>
            )}
          </div>
        )}
        {loading && <Spinner className="spinner" />}
      </Table>
    </Box>
  );
};

export default ReportTable;
